import type Immutable from 'immutable';

import type { ElementChipSelection } from './elementChipsTypes';

type ElementChipsState = {
    selectedChip?: ElementChipSelection | null;
};

const selectElementChipsState = (state: unknown): ElementChipsState | undefined =>
    (state as Immutable.Map<string, unknown>).getIn(['app', 'elementChips']) as ElementChipsState | undefined;

/**
 * Returns the currently selected generic element chip, if any.
 */
export const selectSelectedElementChip = (state: unknown): ElementChipSelection | null => {
    const elementChipsState = selectElementChipsState(state);

    return elementChipsState?.selectedChip ?? null;
};

/**
 * Returns the selected generic element chip ID, if any.
 */
export const selectSelectedElementChipId = (state: unknown): string | undefined =>
    selectSelectedElementChip(state)?.chip.id;

/**
 * Returns the selected chip's element selection owner ID, if any.
 */
export const selectElementIdForSelectedElementChip = (state: unknown): string | undefined =>
    selectSelectedElementChip(state)?.selectedElementId;
